import React, { useState, useRef } from "react";
import { Helmet } from "react-helmet";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";


// Assets
import HeroBgVideo from "../../assets/video/Brain-background-hero-light_5.mp4";
import StarIcon from "../../assets/img/ai_page/star.png";
import IconHeart from "../../assets/img/ai_page/Icon-heart.png";
import IconMoon from "../../assets/img/ai_page/Icon-moon.png";
import IconSun from "../../assets/img/ai_page/Icon sun.png";
import IconUser from "../../assets/img/ai_page/mynaui_user.png";
import DefaultVideoImg from "../../assets/img/ai_page/Imagen-defaultvideo.png";
import DefaultVideoImgMobile from "../../assets/img/ai_page_mobile/Imagen_default_video.png";
import ImgParejas from "../../assets/img/ai_page/Imagen_parejas.png";
import ImgGrupos from "../../assets/img/ai_page/Imagen_grupos.png";
import ImgBusiness from "../../assets/img/ai_page/Imagen_business.png";
import ImgFamilia from "../../assets/img/ai_page/Imagen_familia.png";
import ImgMetasearch from "../../assets/img/ai_page/Imagen_metasearch.png";
import StarIconBadge from "../../assets/img/ai_page_mobile/Icon_star.png";
import ImgParejasMobile from "../../assets/img/ai_page_mobile/imageb_parejas.png";
import ImgGruposMobile from "../../assets/img/ai_page_mobile/imagen_grupos.png";
import ImgBusinessMobile from "../../assets/img/ai_page_mobile/imagen_business.png";
import ImgFamiliaMobile from "../../assets/img/ai_page_mobile/imagen_familia.png";
import ImgMetasearchMobile from "../../assets/img/ai_page_mobile/imagen_metarsearch.png";
import ImgVariantesMotor from "../../assets/img/ai_page/Imagen_variantes_motor.png";
import ImgVariantesMotorMobile from "../../assets/img/ai_page_mobile/Imagen_variantes_motor.png";
import ImgTestAB from "../../assets/img/ai_page/Imagen_testAB.png";
import ImgTestABMobile from "../../assets/img/ai_page_mobile/Imagen_testAB.png";
import ImgMCP from "../../assets/img/ai_page/Imagen_Conexion_MCP_con_las_LLM.png";
import ImgBackoffice from "../../assets/img/ai_page/Imagen_Backoffice_mas_eficiente.png";
import ImgConcierge from "../../assets/img/ai_page/Imagen_Concierge_via_whatsapp.png";
import ImgFondoCanales from "../../assets/img/ai_page/Imagen_fondocanales.png";
import ImgFondoCanalesMobile from "../../assets/img/ai_page_mobile/Imagen_fondocanales.png";
import ArrowsImg from "../../assets/img/ai_page/Arrows.png";
import ArrowsImgMobile from "../../assets/img/ai_page_mobile/Arrows.png";

const YOUTUBE_VIDEO_ID = "gkd4gX5WLIk";

const messages = defineMessages({
  titleSEO: {
    id: "page.aiLanding.titleSEO",
    description: "AI landing page title for SEO",
    defaultMessage: "Witbooking AI - El motor de las mil caras",
  },
  descriptionSEO: {
    id: "page.aiLanding.descriptionSEO",
    description: "AI landing page meta description for SEO",
    defaultMessage: "Witbooking AI convierte la experiencia de reserva en un proceso dinámico y ultra-personalizado, adaptado al perfil y contexto de cada viajero.",
  },
  keywordSEO: {
    id: "page.aiLanding.keywordSEO",
    description: "AI landing page meta keywords for SEO",
    defaultMessage: "Witbooking AI, motor reservas IA, personalización hotel, inteligencia artificial hotelera",
  },
  heroTitle1: {
    id: "page.aiLanding.heroTitle1",
    description: "Hero section title - first line",
    defaultMessage: "Witbooking AI,",
  },
  heroTitle2: {
    id: "page.aiLanding.heroTitle2",
    description: "Hero section title - second line (gradient)",
    defaultMessage: "el motor de las mil caras",
  },
  heroSubtitle: {
    id: "page.aiLanding.heroSubtitle",
    description: "Hero section subtitle",
    defaultMessage: "Convierte la experiencia de reserva en un proceso dinámico y hyper-custom.",
  },
  heroDescription: {
    id: "page.aiLanding.heroDescription",
    description: "Hero section description paragraph",
    defaultMessage: "Nuestra tecnología detecta en tiempo real el perfil del viajero (parejas, familias, business o grupos) y el contexto del viaje (temporada, festividades o eventos) para adaptar los contenidos y la estructura del motor.",
  },
  heroVideoLabel: {
    id: "page.aiLanding.heroVideoLabel",
    description: "Accessible label for the hero video play button",
    defaultMessage: "Reproducir vídeo Witbooking AI",
  },
  useCasesTag: {
    id: "page.aiLanding.useCasesTag",
    description: "Badge label in the use cases section",
    defaultMessage: "Witbooking AI",
  },
  useCasesTitle1: {
    id: "page.aiLanding.useCasesTitle1",
    description: "Use cases section title - first line",
    defaultMessage: "Entiende el contexto y se auto-adapta a los",
  },
  useCasesTitle2: {
    id: "page.aiLanding.useCasesTitle2",
    description: "Use cases section title - second line (gradient)",
    defaultMessage: "diferentes casos de uso.",
  },
  useCase1Name:    { id: "page.aiLanding.useCase1Name",    description: "Use case card name - Couples",         defaultMessage: "Parejas" },
  useCase1Detail1: { id: "page.aiLanding.useCase1Detail1", description: "Use case Couples - detail 1",          defaultMessage: "2 adultos" },
  useCase1Detail2: { id: "page.aiLanding.useCase1Detail2", description: "Use case Couples - detail 2",          defaultMessage: "2 noches de fin de semana" },
  useCase2Name:    { id: "page.aiLanding.useCase2Name",    description: "Use case card name - Groups",          defaultMessage: "Grupos" },
  useCase2Detail1: { id: "page.aiLanding.useCase2Detail1", description: "Use case Groups - detail 1",           defaultMessage: "+ 20 personas" },
  useCase3Name:    { id: "page.aiLanding.useCase3Name",    description: "Use case card name - Business",        defaultMessage: "Business" },
  useCase3Detail1: { id: "page.aiLanding.useCase3Detail1", description: "Use case Business - detail 1",         defaultMessage: "1 adulto" },
  useCase3Detail2: { id: "page.aiLanding.useCase3Detail2", description: "Use case Business - detail 2",         defaultMessage: "1 noche entre semana" },
  useCase4Name:    { id: "page.aiLanding.useCase4Name",    description: "Use case card name - Families",        defaultMessage: "Familias" },
  useCase4Detail1: { id: "page.aiLanding.useCase4Detail1", description: "Use case Families - detail 1",         defaultMessage: "2 adultos y 2 niños" },
  useCase4Detail2: { id: "page.aiLanding.useCase4Detail2", description: "Use case Families - detail 2",         defaultMessage: "15 días en Agosto" },
  useCase5Name:    { id: "page.aiLanding.useCase5Name",    description: "Use case card name - Metasearch",      defaultMessage: "Metasearch" },
  useCase5Detail1: { id: "page.aiLanding.useCase5Detail1", description: "Use case Metasearch - detail 1",       defaultMessage: "El huésped" },
  useCase5Detail2: { id: "page.aiLanding.useCase5Detail2", description: "Use case Metasearch - detail 2",       defaultMessage: "no ha visto la web" },
  variantsTitle1: {
    id: "page.aiLanding.variantsTitle1",
    description: "Motor variants section title - first line",
    defaultMessage: "Un mismo establecimiento,",
  },
  variantsTitle2: {
    id: "page.aiLanding.variantsTitle2",
    description: "Motor variants section title - second line (gradient)",
    defaultMessage: "múltiples variantes del motor.",
  },
  testABTitle:    { id: "page.aiLanding.testABTitle",    description: "A/B Test section title",                    defaultMessage: "Test A/B" },
  testABSubtitle: { id: "page.aiLanding.testABSubtitle", description: "A/B Test section subtitle",                 defaultMessage: "Crea distintas versiones y compara resultados" },
  testABTag1:     { id: "page.aiLanding.testABTag1",     description: "A/B Test metric tag - Visits",              defaultMessage: "Visitas" },
  testABTag2:     { id: "page.aiLanding.testABTag2",     description: "A/B Test metric tag - Total Bookings",      defaultMessage: "Reservas Totales" },
  testABTag3:     { id: "page.aiLanding.testABTag3",     description: "A/B Test metric tag - ADR",                 defaultMessage: "ADR (€)" },
  testABTag4:     { id: "page.aiLanding.testABTag4",     description: "A/B Test metric tag - Conversion Rate",     defaultMessage: "Tasa de conversión (%)" },
  testABTag5:     { id: "page.aiLanding.testABTag5",     description: "A/B Test metric tag - Revenue",             defaultMessage: "Revenue generado (€)" },
  channelsTitle: {
    id: "page.aiLanding.channelsTitle",
    description: "Channels section title",
    defaultMessage: "Te acompañamos en todos los canales",
  },
  channelsSubtitle: {
    id: "page.aiLanding.channelsSubtitle",
    description: "Channels section subtitle",
    defaultMessage: "Optimizamos cada interacción: desde la captación con IA hasta la gestión operativa y el servicio al huésped.",
  },
  channel1Tag:          { id: "page.aiLanding.channel1Tag",          description: "Channel card 1 (MCP/LLM) tag label",                                        defaultMessage: "Conexión MCP con las LLM" },
  channel1TitleStrong:  { id: "page.aiLanding.channel1TitleStrong",  description: "Channel card 1 - bold text in body",                                        defaultMessage: "contenidos del hotel" },
  channel1Body1:        { id: "page.aiLanding.channel1Body1",        description: "Channel card 1 - first paragraph. Use {strong} for bold text.",             defaultMessage: "Mostramos los {strong} en las conversaciones con la IA de Chat GPT." },
  channel1Text:         { id: "page.aiLanding.channel1Text",         description: "Channel card 1 - second paragraph",                                         defaultMessage: "Así, aprovechamos 1.600.000 usuarios para conseguir nuevos leads." },
  channel2Tag:          { id: "page.aiLanding.channel2Tag",          description: "Channel card 2 (Back Office) tag label",                                    defaultMessage: "Back Office más eficiente" },
  channel2TitleStrong:  { id: "page.aiLanding.channel2TitleStrong",  description: "Channel card 2 - bold text in body",                                        defaultMessage: "flujos de trabajo complejos en acciones rápidas" },
  channel2Body1:        { id: "page.aiLanding.channel2Body1",        description: "Channel card 2 - body paragraph. Use {strong} for bold text.",              defaultMessage: "Mejoramos tu eficiencia operativa: Transformamos {strong}." },
  channel3Tag:          { id: "page.aiLanding.channel3Tag",          description: "Channel card 3 (WhatsApp Concierge) tag label",                             defaultMessage: "Concierge via WhatsApp" },
  channel3Text1:        { id: "page.aiLanding.channel3Text1",        description: "Channel card 3 - first paragraph",                                          defaultMessage: "El agente IA habla con tu huésped antes y durante la estancia." },
  channel3Text2:        { id: "page.aiLanding.channel3Text2",        description: "Channel card 3 - second paragraph. Use {strong1}, {strong2}, {strong3}.",   defaultMessage: "Ofrece información del hotel y propone {strong1} de {strong2} y {strong3}." },
  channel3Text2Strong1: { id: "page.aiLanding.channel3Text2Strong1", description: "Channel card 3 - bold word 1 in second paragraph",                          defaultMessage: "upgrades" },
  channel3Text2Strong2: { id: "page.aiLanding.channel3Text2Strong2", description: "Channel card 3 - bold word 2 in second paragraph",                          defaultMessage: "habitación, pensión, extras" },
  channel3Text2Strong3: { id: "page.aiLanding.channel3Text2Strong3", description: "Channel card 3 - bold word 3 in second paragraph",                          defaultMessage: "actividades en destino" },
  channelPrev:          { id: "page.aiLanding.channelPrev",          description: "Accessible label for previous channel button",                               defaultMessage: "Canal anterior" },
  channelNext:          { id: "page.aiLanding.channelNext",          description: "Accessible label for next channel button",                                   defaultMessage: "Canal siguiente" },
});

export default function AiLanding() {
  const intl = useIntl();
  const [videoPlaying, setVideoPlaying] = useState(false);

  // Ref for the channels scrollable viewport
  const channelViewportRef = useRef(null);

  const handleChannelPrev = () => {
    const el = channelViewportRef.current;
    if (!el) return;
    const card = el.querySelector('.ai-channel-card');
    const gap = 66;
    const step = (card?.offsetWidth || 350) + gap;
    el.scrollBy({ left: -step, behavior: 'smooth' });
  };

  const handleChannelNext = () => {
    const el = channelViewportRef.current;
    if (!el) return;
    const card = el.querySelector('.ai-channel-card');
    const gap = 66;
    const step = (card?.offsetWidth || 350) + gap;
    el.scrollBy({ left: step, behavior: 'smooth' });
  };

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage(messages.titleSEO)}</title>
        <meta name="title"        content={intl.formatMessage(messages.titleSEO)} />
        <meta name="description"  content={intl.formatMessage(messages.descriptionSEO)} />
        <meta name="keywords"     content={intl.formatMessage(messages.keywordSEO)} />
        <meta property="og:type"        content="website" />
        <meta property="og:title"       content={intl.formatMessage(messages.titleSEO)} />
        <meta property="og:description" content={intl.formatMessage(messages.descriptionSEO)} />
        <meta property="twitter:card"        content="summary_large_image" />
        <meta property="twitter:title"       content={intl.formatMessage(messages.titleSEO)} />
        <meta property="twitter:description" content={intl.formatMessage(messages.descriptionSEO)} />
      </Helmet>

      <section className="ai-hero-section">
        <video
          className="ai-hero-bg-video"
          autoPlay
          muted
          loop
          playsInline
          aria-hidden="true"
        >
          <source src={HeroBgVideo} type="video/mp4" />
        </video>

        <div className="ai-hero-bg-overlay" aria-hidden="true" />

        <div className="ai-hero-inner">
          <div className="ai-hero-spark" aria-hidden="true">
            <img src={StarIcon} alt="" />
          </div>

          <h1 className="ai-hero-title">
            <FormattedMessage {...messages.heroTitle1} />{" "}
            <span className="ai-hero-title-gradient">
              <FormattedMessage {...messages.heroTitle2} />
            </span>
          </h1>

          <p className="ai-hero-subtitle">
            <FormattedMessage {...messages.heroSubtitle} />
          </p>

          <p className="ai-hero-description">
            <FormattedMessage {...messages.heroDescription} />
          </p>

          <div className="ai-hero-video-wrap">
            <div className="ai-hero-glass" aria-hidden="true" />
            <div className="ai-hero-video">
              {videoPlaying ? (
                <iframe
                  className="ai-hero-iframe"
                  src={`https://www.youtube-nocookie.com/embed/${YOUTUBE_VIDEO_ID}?autoplay=1&rel=0&modestbranding=1`}
                  title="Witbooking AI"
                  style={{ border: "none" }}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              ) : (
                <button
                  className="ai-hero-thumbnail"
                  onClick={() => setVideoPlaying(true)}
                  aria-label={intl.formatMessage(messages.heroVideoLabel)}
                >
                  <picture>
                    <source media="(max-width: 767px)" srcSet={DefaultVideoImgMobile} />
                    <img
                      src={DefaultVideoImg}
                      alt="Witbooking AI preview"
                      className="ai-hero-thumb-img"
                    />
                  </picture>
                  <span className="ai-hero-play-btn" aria-hidden="true">
                    <svg viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="30" cy="30" r="30" fill="rgba(255,255,255,0.9)" />
                      <polygon points="24,18 46,30 24,42" fill="#2E3862" />
                    </svg>
                  </span>
                </button>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="ai-usecases-section">
        <div className="big-wrapper">
          <div className="ai-usecases-bg">
            <div className="ai-usecases-layout">

              <div className="ai-usecases-intro">
                <span className="ai-badge">
                  <img src={StarIconBadge} alt="" aria-hidden="true" />
                  <FormattedMessage {...messages.useCasesTag} />
                </span>
                <h2 className="ai-usecases-title">
                  <FormattedMessage {...messages.useCasesTitle1} />{" "}
                  <span className="ai-text-gradient">
                    <FormattedMessage {...messages.useCasesTitle2} />
                  </span>
                </h2>
              </div>

              <div className="ai-usecase-card ai-usecase-card--parejas">
                <div className="ai-usecase-card-content">
                  <span className="ai-usecase-tag"><FormattedMessage {...messages.useCase1Name} /></span>
                  <div className="ai-usecase-details">
                    <p><img src={IconUser} alt="" aria-hidden="true" /><FormattedMessage {...messages.useCase1Detail1} /></p>
                    <p><img src={IconHeart} alt="" aria-hidden="true" /><FormattedMessage {...messages.useCase1Detail2} /></p>
                  </div>
                </div>
                <div className="ai-usecase-image">
                  <picture>
                    <source media="(max-width: 767px)" srcSet={ImgParejasMobile} />
                    <img src={ImgParejas} alt="" aria-hidden="true" />
                  </picture>
                </div>
              </div>

              <div className="ai-usecase-card ai-usecase-card--grupos">
                <div className="ai-usecase-image">
                  <picture>
                    <source media="(max-width: 767px)" srcSet={ImgGruposMobile} />
                    <img src={ImgGrupos} alt="" aria-hidden="true" />
                  </picture>
                </div>
                <div className="ai-usecase-card-content">
                  <span className="ai-usecase-tag"><FormattedMessage {...messages.useCase2Name} /></span>
                  <div className="ai-usecase-details">
                    <p><img src={IconUser} alt="" aria-hidden="true" /><FormattedMessage {...messages.useCase2Detail1} /></p>
                  </div>
                </div>
              </div>

              <div className="ai-usecase-card ai-usecase-card--business">
                <div className="ai-usecase-image">
                  <picture>
                    <source media="(max-width: 767px)" srcSet={ImgBusinessMobile} />
                    <img src={ImgBusiness} alt="" aria-hidden="true" />
                  </picture>
                </div>
                <div className="ai-usecase-card-content">
                  <span className="ai-usecase-tag"><FormattedMessage {...messages.useCase3Name} /></span>
                  <div className="ai-usecase-details">
                    <p><img src={IconUser} alt="" aria-hidden="true" /><FormattedMessage {...messages.useCase3Detail1} /></p>
                    <p><img src={IconMoon} alt="" aria-hidden="true" /><FormattedMessage {...messages.useCase3Detail2} /></p>
                  </div>
                </div>
              </div>

              <div className="ai-usecase-card ai-usecase-card--familias">
                <div className="ai-usecase-card-content">
                  <span className="ai-usecase-tag"><FormattedMessage {...messages.useCase4Name} /></span>
                  <div className="ai-usecase-details">
                    <p><img src={IconUser} alt="" aria-hidden="true" /><FormattedMessage {...messages.useCase4Detail1} /></p>
                    <p><img src={IconSun}  alt="" aria-hidden="true" /><FormattedMessage {...messages.useCase4Detail2} /></p>
                  </div>
                </div>
                <div className="ai-usecase-image">
                  <picture>
                    <source media="(max-width: 767px)" srcSet={ImgFamiliaMobile} />
                    <img src={ImgFamilia} alt="" aria-hidden="true" />
                  </picture>
                </div>
              </div>

              <div className="ai-usecase-card ai-usecase-card--metasearch">
                <div className="ai-usecase-card-content">
                  <span className="ai-usecase-tag"><FormattedMessage {...messages.useCase5Name} /></span>
                  <div className="ai-usecase-details">
                    <p>
                      <img src={IconUser} alt="" aria-hidden="true" />
                      <span>
                        <FormattedMessage {...messages.useCase5Detail1} />{" "}
                        <FormattedMessage {...messages.useCase5Detail2} />
                      </span>
                    </p>
                  </div>
                </div>
                <div className="ai-usecase-image">
                  <picture>
                    <source media="(max-width: 767px)" srcSet={ImgMetasearchMobile} />
                    <img src={ImgMetasearch} alt="" aria-hidden="true" />
                  </picture>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      <section className="ai-variants-section">
        <div className="big-wrapper">
          <div className="ai-variants-inner">
            <div className="ai-variants-text">
              <h2 className="ai-variants-title">
                <span className="ai-variants-title-dark">
                  <FormattedMessage {...messages.variantsTitle1} />
                </span>{" "}
                <span className="ai-text-gradient">
                  <FormattedMessage {...messages.variantsTitle2} />
                </span>
              </h2>
            </div>
            <div className="ai-variants-image">
              <picture>
                <source media="(max-width: 767px)" srcSet={ImgVariantesMotorMobile} />
                <img
                  src={ImgVariantesMotor}
                  alt="Motor de reservas — múltiples variantes"
                />
              </picture>
            </div>
          </div>
        </div>
      </section>

      <section className="ai-testab-section">
        <div className="big-wrapper">
          <div className="ai-testab-inner">
            <div className="ai-testab-content">
              <h2 className="ai-testab-title">
                <FormattedMessage {...messages.testABTitle} />
              </h2>
              <p className="ai-testab-subtitle">
                <FormattedMessage {...messages.testABSubtitle} />
              </p>
              <div className="ai-testab-tags">
                <span className="ai-testab-tag"><FormattedMessage {...messages.testABTag1} /></span>
                <span className="ai-testab-tag"><FormattedMessage {...messages.testABTag2} /></span>
                <span className="ai-testab-tag"><FormattedMessage {...messages.testABTag3} /></span>
                <span className="ai-testab-tag"><FormattedMessage {...messages.testABTag4} /></span>
                <span className="ai-testab-tag"><FormattedMessage {...messages.testABTag5} /></span>
              </div>
            </div>
            <div className="ai-testab-graph">
              <picture>
                <source media="(max-width: 767px)" srcSet={ImgTestABMobile} />
                <img src={ImgTestAB} alt="Gráfico comparativo Test A/B" />
              </picture>
            </div>
          </div>
        </div>
      </section>

      <section className="ai-channels-section">
        <img
          src={ImgFondoCanales}
          alt=""
          aria-hidden="true"
          className="ai-channels-bg-img ai-channels-bg-img--desktop"
        />
        <img
          src={ImgFondoCanalesMobile}
          alt=""
          aria-hidden="true"
          className="ai-channels-bg-img ai-channels-bg-img--mobile"
        />

        <div className="big-wrapper">
          <div className="ai-channels-header">
            <h2 className="ai-channels-title">
              <FormattedMessage {...messages.channelsTitle} />
            </h2>
            <p className="ai-channels-subtitle">
              <FormattedMessage {...messages.channelsSubtitle} />
            </p>
          </div>

          <div className="ai-channels-viewport" ref={channelViewportRef}>
            <div className="ai-channels-track">

              {/* Card 1 — MCP / LLM */}
              <article className="ai-channel-card">
                <div className="ai-channel-card-image ai-channel-card-image--mcp">
                  <img src={ImgMCP} alt="" aria-hidden="true" />
                </div>
                <div className="ai-channel-card-body">
                  <span className="ai-channel-tag">
                    <FormattedMessage {...messages.channel1Tag} />
                  </span>
                  <div className="ai-channel-card-texts">
                    <p className="channel-card-text">
                      <FormattedMessage
                        {...messages.channel1Body1}
                        values={{
                          strong: (
                            <strong>
                              <FormattedMessage {...messages.channel1TitleStrong} />
                            </strong>
                          ),
                        }}
                      />
                    </p>
                    <p className="channel-card-text">
                      <FormattedMessage {...messages.channel1Text} />
                    </p>
                  </div>
                </div>
              </article>

              {/* Card 2 — Back Office */}
              <article className="ai-channel-card">
                <div className="ai-channel-card-image ai-channel-card-image--backoffice">
                  <img src={ImgBackoffice} alt="" aria-hidden="true" />
                </div>
                <div className="ai-channel-card-body">
                  <span className="ai-channel-tag">
                    <FormattedMessage {...messages.channel2Tag} />
                  </span>
                  <div className="ai-channel-card-texts">
                    <p className="channel-card-text">
                      <FormattedMessage
                        {...messages.channel2Body1}
                        values={{
                          strong: (
                            <strong>
                              <FormattedMessage {...messages.channel2TitleStrong} />
                            </strong>
                          ),
                        }}
                      />
                    </p>
                  </div>
                </div>
              </article>

              {/* Card 3 — WhatsApp Concierge */}
              <article className="ai-channel-card">
                <div className="ai-channel-card-image ai-channel-card-image--concierge">
                  <img src={ImgConcierge} alt="" aria-hidden="true" />
                </div>
                <div className="ai-channel-card-body">
                  <span className="ai-channel-tag">
                    <FormattedMessage {...messages.channel3Tag} />
                  </span>
                  <div className="ai-channel-card-texts">
                    <p className="channel-card-text">
                      <FormattedMessage {...messages.channel3Text1} />
                    </p>
                    <p className="channel-card-text">
                      <FormattedMessage
                        {...messages.channel3Text2}
                        values={{
                          strong1: <strong><FormattedMessage {...messages.channel3Text2Strong1} /></strong>,
                          strong2: <strong><FormattedMessage {...messages.channel3Text2Strong2} /></strong>,
                          strong3: <strong><FormattedMessage {...messages.channel3Text2Strong3} /></strong>,
                        }}
                      />
                    </p>
                  </div>
                </div>
              </article>

            </div>
          </div>

          <div className="ai-channels-nav">
            <div className="ai-channels-nav-arrows">
              <picture>
                <source media="(max-width: 767px)" srcSet={ArrowsImgMobile} />
                <img src={ArrowsImg} alt="" aria-hidden="true" className="ai-channels-arrows-img" />
              </picture>
              <button
                className="ai-channels-nav-btn ai-channels-nav-btn--prev"
                onClick={handleChannelPrev}
                aria-label={intl.formatMessage(messages.channelPrev)}
              />
              <button
                className="ai-channels-nav-btn ai-channels-nav-btn--next"
                onClick={handleChannelNext}
                aria-label={intl.formatMessage(messages.channelNext)}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
